module.exports = __webpack_public_path__ + "static/reflecting-7c23f7ec4a6cb3b80ef49ff094177802.png";